import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const DeleteIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  ({ tooltipTitle, ...props }, ref) => {
    const { t } = useTranslation();
    const resolvedTooltipTitle = tooltipTitle ?? t('common.delete', 'Delete');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={resolvedTooltipTitle}
      >
        <DeleteIcon color="inherit" />
      </IconButton>
    );
  },
);

DeleteIconButton.displayName = 'DeleteIconButton';
export default DeleteIconButton;
